/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationTypeFromJSON, NotificationTypeToJSON, } from './NotificationType';
/**
 * Check if a given object implements the NotificationDto interface.
 */
export function instanceOfNotificationDto(value) {
    let isInstance = true;
    return isInstance;
}
export function NotificationDtoFromJSON(json) {
    return NotificationDtoFromJSONTyped(json, false);
}
export function NotificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : NotificationTypeFromJSON(json['type']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'linkPath': !exists(json, 'linkPath') ? undefined : json['linkPath'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'readAt': !exists(json, 'readAt') ? undefined : (json['readAt'] === null ? null : new Date(json['readAt'])),
    };
}
export function NotificationDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': NotificationTypeToJSON(value.type),
        'title': value.title,
        'body': value.body,
        'linkPath': value.linkPath,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'readAt': value.readAt === undefined ? undefined : (value.readAt === null ? null : value.readAt.toISOString()),
    };
}
